export class TimeInMilliseconds {
    public static readonly SECOND = 1000;
    public static readonly MINUTE = TimeInMilliseconds.SECOND * 60;
    public static readonly HOUR = TimeInMilliseconds.MINUTE * 60;
    public static readonly DAY = TimeInMilliseconds.HOUR * 24;
}
